<template>
	<address class="h-adr" itemtype="http://schema.org/PostalAddress">
		<span v-if="empty">—</span>
		<dl v-else>
			<div v-if="street">
				<dt>Street</dt>
				<dd class="p-street-address" itemprop="streetAddress" v-html="street"/>
			</div>
			<div v-if="locality">
				<dt>Locality</dt>
				<dd class="p-locality" itemprop="addressLocality" v-html="locality"/>
			</div>
			<div v-if="city">
				<dt>City</dt>
				<dd class="p-locality" itemprop="addressLocality" v-html="city"/>
			</div>
			<div v-if="province">
				<dt>Province</dt>
				<dd class="p-region" itemprop="addressRegion" v-html="province"/>
			</div>
			<div v-if="postcode">
				<dt>Postcode</dt>
				<dd class="p-postal-code" itemprop="postalCode" v-html="postcode"/>
			</div>
			<div v-if="country">
				<dt>Country</dt>
				<dd class="p-country-name" itemprop="addressCountry" v-html="country"/>
			</div>
		</dl>
	</address>
</template>
<script>
export default {
	computed: {
		empty() {
			return ![
				this.street,
				this.locality,
				this.city,
				this.province,
				this.postcode,
				this.countryCode,
			].filter(n => n).length;
		},
		normalizedAddress() {
			return _.mapKeys(this.address, (value, key) => {
				return this.stringer(key).replace("address_").camel().value;
			});
		},
		street() {
			if (!this.normalizedAddress.identifier && !this.normalizedAddress.street) {
				return null;
			}

			return [this.normalizedAddress.identifier, this.normalizedAddress.street].join(" ").trim(" ");
		},
		locality() {
			return this.normalizedAddress.locality;
		},
		city() {
			return this.normalizedAddress.city;
		},
		province() {
			return this.normalizedAddress.province;
		},
		postcode() {
			return this.stringer(this.normalizedAddress.postcode).upper().value;
		},
		countryCode() {
			return this.normalizedAddress.countryCode;
		},
		country() {
			return this.normalizedAddress.country;
		},
	},
	props: {
		address: {
			required: true,
			type: Object,
		},
	},
};
</script>
